import { render } from "./TitleContent.vue?vue&type=template&id=37818aff"
import script from "./TitleContent.vue?vue&type=script&lang=js"
export * from "./TitleContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__